import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ClipboardList, LogOut } from 'lucide-react';

export default function TechLayout({ title, children }) {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    { key: 'jobs', label: 'Jobs', icon: ClipboardList, path: '/tech/jobs' },
  ];

  return (
    <div style={{ minHeight: '100vh', background: '#F9FAFB', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <div
        style={{
          position: 'sticky',
          top: 0,
          zIndex: 20,
          background: '#fff',
          borderBottom: '1px solid #E5E7EB',
          padding: '14px 16px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div>
          <div style={{ fontSize: 12, color: '#6B7280', fontWeight: 600 }}>Service Tech Manager</div>
          <div style={{ fontSize: 18, fontWeight: 700, color: '#111827' }}>{title}</div>
        </div>

        <button
          onClick={() => {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            navigate('/login');
          }}
          style={{
            border: 'none',
            background: '#F3F4F6',
            color: '#374151',
            borderRadius: 8,
            padding: '8px 10px',
            cursor: 'pointer',
          }}
        >
          <LogOut size={18} />
        </button>
      </div>

      {/* Main */}
      <div style={{ flex: 1, padding: '16px 16px 84px 16px' }}>
        {children}
      </div>

      {/* Bottom Nav */}
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          left: 0,
          right: 0,
          background: '#fff',
          borderTop: '1px solid #E5E7EB',
          display: 'grid',
          gridTemplateColumns: '1fr',
          padding: '8px 8px calc(8px + env(safe-area-inset-bottom, 0px))',
          zIndex: 30,
        }}
      >
        {navItems.map(item => {
          const Icon = item.icon;
          const active = location.pathname.startsWith(item.path);

          return (
            <button
              key={item.key}
              onClick={() => navigate(item.path)}
              style={{
                border: 'none',
                background: 'none',
                padding: '8px 0',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 4,
                color: active ? '#2563EB' : '#6B7280',
                fontWeight: active ? 700 : 500,
                cursor: 'pointer',
              }}
            >
              <Icon size={18} />
              <span style={{ fontSize: 12 }}>{item.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}